import { AppRoute, default as Routes, isLoginLandingPage } from './routes';
export  { type AppRoute, isLoginLandingPage };
export default Routes;
